// import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
// import createReducer from './_reducers';

// export default function appStore(initialState = {}) {
//   return configureStore({
//     reducer: createReducer(),
//     middleware: [...getDefaultMiddleware()],
//     preloadedState: initialState,
//     devTools: process.env.NODE_ENV !== 'production',
//   });
// }

import { configureStore } from '@reduxjs/toolkit';
import createReducer from './_reducers';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { createLogger } from 'redux-logger';

const persistConfig = {
  key: 'root',
  storage,
};

export default function appStore(initialState = {}) {
  const rootReducer = createReducer();
  const logger = createLogger({
    collapsed: true,
  });

  const persistedReducer = persistReducer(persistConfig, rootReducer);

  const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => {
      const middlewares = getDefaultMiddleware({
        serializableCheck: false,
      });
      if (process.env.NODE_ENV === 'development') {
        return middlewares.concat(logger);
      }
      return middlewares;
    },
    preloadedState: initialState,
    devTools: process.env.NODE_ENV !== 'production',
  });

  const persistor = persistStore(store);

  return { store, persistor };
}